exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-link {\n  font-size: 1.75rem; }\n\n.display-details {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  padding-top: 0;\n  padding-bottom: 0; }\n\n.projectname {\n  overflow: hidden;\n  width: 800px;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.projectname:hover {\n  overflow: visible;\n  white-space: normal;\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/market-banner/market-banner.component.scss
// module id = ../../../../../src/app/market-banner/market-banner.component.scss
// module chunks = main